<template>
  <div>
    <label
        v-if="label"
        for=""
        class="vs-input--label"
    ><span>{{ label }}</span></label>

    <v-select
        v-model="selected"
        :options="users"
        @search="fetchUsers"
        :placeholder="placeholder"
    ></v-select>
    <div class="con-text-validation span-text-validation vs-input--text-validation-span">
      <span class="span-text-validation">{{ helpText || ''}}</span>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import {http} from '@/services'

  export default {
    name: 'UsersSearch',
    components: {
      vSelect
    },
    props: ['selectedUser', 'label', 'placeholder', 'helpText'],
    computed: {
      selected: {
        set (value) {
          this.$emit('selected', value)
        },
        get () {
          return this.selectedUser
        }
      }
    },
    data () {
      return {
        users: [],
      }
    },
    methods: {
      fetchUsers (search, loading) {
        if (search) {
          http.get('users_widget/' + search).then(
          response => {
            this.users = response.data
          }
          ).catch(
          error => {
            console.log(error)
          }
          )
        } else {
          this.users = []
        }
      }
    }
  }
</script>

<style>
</style>
